import { Box, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import { ReactNode } from 'react';

type CellTooltipProps = {
  info: TooltipItem[];
};

export type TooltipItem = {
  label: string;
  value?: ReactNode;
};

export const CellTooltip = ({ info }: CellTooltipProps) => {
  if (isEmpty(info)) {
    return null;
  }
  return (
    <Box>
      {info
        .filter((item) => item.value)
        .map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              flexWrap: 'nowrap',
              fontWeight: 400,
              alignItems: 'center',
            }}
          >
            <Typography
              fontWeight={500}
              fontSize={14}
              pr={1}
              whiteSpace='nowrap'
            >
              {item.label}
            </Typography>
            <Box sx={{ fontSize: 14, whiteSpace: 'nowrap' }}>{item.value}</Box>
          </Box>
        ))}
    </Box>
  );
};
